import React, { Component } from "react";
import NotificationPanel from "./NotificationPanel/index";
import Events from "../../../../utilities/EventEmitter";
import { inject, observer } from "mobx-react";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import withWidth from "@material-ui/core/withWidth";


const styles = () => ({
  notificationContainer: {
    height: "auto",
  },
  desktopContainer: {
    top: 43,
  },
  tabContainer: {
    top: 45,
    right: -28,
  },
});

@inject("DispatchStore")
@observer
export class Notifications extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toastsNotifications: [],
    };
    this.timer = null;
  }

  componentDidMount() {
    Events.on("showToastMessageNotification", this.showToastNotification);
  }

  componentWillUnmount() {
    Events.off("showToastMessageNotification", this.showToastNotification);
    clearTimeout(this.timer);
  }

  showToastNotification = (data) => {
    let msgData = JSON.parse(data);
    msgData.driver = this.props.DispatchStore.getCurrentDriver(msgData.sender);
    if (!msgData.driver) {
      return;
    }

    this.setState((prevState) => ({
      toastsNotifications: [msgData, ...prevState.toastsNotifications].slice(
        0,
        3
      ),
    }));
    this.timer = setTimeout(() => {
      this.removeNotification();
    }, 3000);
  };

  removeNotification = () => {
    this.setState((prevState) => ({
      toastsNotifications: prevState.toastsNotifications.slice(1),
    }));
  };

  render() {
    const { toastsNotifications } = this.state;
    const { classes, width, openDriverChatBox } = this.props;
    return (
      <>
        {Boolean(toastsNotifications.length) && (
          <NotificationPanel
            data={toastsNotifications}
            openDriverChatBox={openDriverChatBox}
            containerStyles={`${
              ["xl", "lg"].includes(width)
                ? classes.desktopContainer
                : classes.tabContainer
            } ${classes.notificationContainer}`}
          />
        )}
      </>
    );
  }
}
export default compose(withWidth(), withStyles(styles))(Notifications);
